import { useCurrentFrame, useVideoConfig, interpolate, Easing, AbsoluteFill, spring } from "remotion";
import { loadFont as loadInter } from "@remotion/google-fonts/Inter";

const { fontFamily: inter } = loadInter("normal", { weights: ["600", "700", "800"], subsets: ["latin"] });

const TempleMiniSVG: React.FC = () => (
  <svg width="32" height="35" viewBox="0 0 110 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5" y="100" width="100" height="10" rx="2" fill="#C8A96E" />
    <rect x="18" y="72" width="74" height="30" rx="2" fill="#E8C97E" stroke="#8B6914" strokeWidth="1.5" />
    <path d="M42 102 L42 82 Q55 72 68 82 L68 102Z" fill="#5C3D1E" />
    <path d="M12 72 L98 72 L90 58 L20 58Z" fill="#D4A853" stroke="#8B6914" strokeWidth="1" />
    <path d="M22 58 L88 58 L80 44 L30 44Z" fill="#E8C97E" stroke="#8B6914" strokeWidth="1" />
    <path d="M32 44 L78 44 L70 32 L40 32Z" fill="#D4A853" stroke="#8B6914" strokeWidth="1" />
    <path d="M40 32 L70 32 L55 8Z" fill="#E8C97E" stroke="#8B6914" strokeWidth="1" />
    <circle cx="55" cy="8" r="4" fill="#FFD700" />
    <line x1="55" y1="72" x2="55" y2="80" stroke="#8B6914" strokeWidth="2" />
    <path d="M55 80 C55 80 46 82 45 90 L65 90 C64 82 55 80 55 80Z" fill="#FFD700" stroke="#B8860B" strokeWidth="1" />
    <ellipse cx="55" cy="90" rx="10" ry="3.5" fill="#B8860B" />
  </svg>
);

export const DevaKathaLS3: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const slideX = spring({ frame, fps, config: { damping: 14, stiffness: 90 }, durationInFrames: Math.round(1 * fps) });
  const translateX = interpolate(slideX, [0, 1], [280, 0]);

  const slideOut = interpolate(frame, [Math.round(3.5 * fps), Math.round(4 * fps)], [0, 280], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
    easing: Easing.bezier(0.4, 0, 1, 1),
  });

  const likeClicked = frame >= Math.round(1.5 * fps);
  const subClicked = frame >= Math.round(2.3 * fps);

  const likeScale = interpolate(frame,
    [Math.round(1.5 * fps), Math.round(1.57 * fps), Math.round(1.7 * fps)],
    [1, 0.87, 1.06], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });

  const subScale = interpolate(frame,
    [Math.round(2.3 * fps), Math.round(2.37 * fps), Math.round(2.5 * fps)],
    [1, 0.87, 1.06], { extrapolateRight: "clamp", extrapolateLeft: "clamp" });

  return (
    <AbsoluteFill style={{ overflow: 'hidden' }}>
      <div style={{ position: 'absolute', inset: 0, transform: 'scale(1.5)', transformOrigin: 'bottom right' }}>
      <div style={{
        position: "absolute",
        bottom: 53,
        right: 16,
        transform: `translateX(${translateX + slideOut}px)`,
        display: "flex",
        alignItems: "center",
        gap: 9,
        background: "rgba(20,20,20,0.92)",
        backdropFilter: "blur(12px)",
        borderRadius: 9,
        padding: "9px 12px",
        border: "1px solid rgba(255,215,0,0.25)",
        boxShadow: "0 4px 24px rgba(0,0,0,0.7), 0 0 0 1px rgba(255,255,255,0.05)",
        minWidth: 213,
      }}>
        <TempleMiniSVG />

        <div style={{ width: 1, height: 33, background: "rgba(255,255,255,0.15)" }} />

        <div style={{ display: "flex", flexDirection: "column", gap: 5, flex: 1 }}>
          <div style={{ color: "rgba(255,255,255,0.5)", fontSize: 7, fontWeight: 600, fontFamily: inter, letterSpacing: 1.2, textTransform: "uppercase" }}>
            Deva Katha
          </div>
          <div style={{ display: "flex", gap: 5 }}>
            <div style={{
              display: "flex", alignItems: "center", gap: 4,
              background: likeClicked ? "#1a73e8" : "rgba(255,255,255,0.1)",
              borderRadius: 13, padding: "4px 9px",
              transform: `scale(${likeScale})`,
              border: `1px solid ${likeClicked ? "transparent" : "rgba(255,255,255,0.15)"}`,
            }}>
              <span style={{ color: "#fff", fontSize: 9, fontWeight: 700, fontFamily: inter }}>
                {likeClicked ? "👍 Liked" : "👍 Like"}
              </span>
            </div>
            <div style={{
              display: "flex", alignItems: "center",
              background: subClicked ? "#606060" : "#FF0000",
              borderRadius: 13, padding: "4px 9px",
              transform: `scale(${subScale})`,
              boxShadow: subClicked ? "none" : "0 2px 12px rgba(255,0,0,0.5)",
            }}>
              <span style={{ color: "#fff", fontSize: 9, fontWeight: 800, fontFamily: inter }}>
                {subClicked ? "Subscribed ✓" : "Subscribe"}
              </span>
            </div>
          </div>
        </div>
      </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
